import React from 'react'
import PropTypes from 'prop-types'
import strings from 'utils/strings'
import { classNames } from 'utils/utils'
import { mockEvent } from 'utils/events'
import { Input } from 'antd'
import withInputStyle from 'components/deprecated/Inputs/Input.style'
// eslint-disable-next-line import/no-cycle
import { Icon } from 'components/patterns'
import withStyle, { SearchIcon } from './SearchInput.style'

const SearchInput = ({
  className,
  value,
  placeholder,
  onChange,
  onClear,
  width,
  onSearch,
  addOnAfter,
  maxLength,
}) => (
  <div className={classNames(className, 'SearchInput')}>
    <Input
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      width={width}
      type="search"
      maxLength={maxLength}
      onPressEnter={onSearch}
      addonAfter={
        addOnAfter ? (
          <>
            <SearchIcon
              icon="search"
              hoverFill="blueSecondary"
              onClick={() => onSearch(mockEvent(value))}
            />
            {value && onClear && (
              <Icon icon="cancel" hoverFill="blueSecondary" onClick={onClear} />
            )}
          </>
        ) : null
      }
    />
  </div>
)

SearchInput.defaultProps = {
  value: '',
  placeholder: strings.enter_search_term,
  size: 'default',
  maxLength: 80,
}

SearchInput.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  clear: PropTypes.bool,
  width: PropTypes.string,
  onSearch: PropTypes.func,
  onClear: PropTypes.func,
  size: PropTypes.string,
  addOnAfter: PropTypes.bool,
  maxLength: PropTypes.number,
}

export default withInputStyle(withStyle(SearchInput))
